import { render, staticRenderFns } from "./loginCallback.vue?vue&type=template&id=f2c69574&"
import script from "./loginCallback.vue?vue&type=script&lang=js&"
export * from "./loginCallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/src/SelfService.App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2c69574')) {
      api.createRecord('f2c69574', component.options)
    } else {
      api.reload('f2c69574', component.options)
    }
    module.hot.accept("./loginCallback.vue?vue&type=template&id=f2c69574&", function () {
      api.rerender('f2c69574', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/authentication/loginCallback/loginCallback.vue"
export default component.exports